import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import API from "../utils/apiClient";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState("");

  // useEffect(() => {
  //   const fetchUserData = async () => {
  //     const token = localStorage.getItem('user_token');

  //     if (!token) {
  //       console.log("User is not logged in");
  //       setLoading(false);
  //       return;
  //     }

  //     try {
  //       const payload = JSON.parse(atob(token.split(".")[1]));
  //       setUserId(payload.id);
  //       const response = await API.get(`/user/initials/${payload.id}`);
  //       setUser(response.data);
  //     } catch (err) {
  //       setError(err.response ? err.response.data : err.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchUserData();
  // }, []);

  return (
    <UserContext.Provider value={{ user, loading, error, userId }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to use the UserContext
export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
};
